<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Workspaces</h1>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                    <a :href="`/#/admin/organizations/workspaces/create/${tid}`" role="button" class="btn btn-success text-white" style="padding: 0.7em 2em;">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        Add workspace
                    </a>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <table v-if="workspaces.length" class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col" style="border-top: none;">#</th>
                        <th scope="col" style="border-top: none;">Name</th>
                        <th scope="col" style="border-top: none;">Description</th>
                        <th scope="col" style="border-top: none;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(w, i) in workspaces" :key="w.WorkspaceId">
                        <th scope="row">{{i+1}}</th>
                        <td><a :href="`/#/admin/organizations/workspaces/manage/${w.WorkspaceId}`">{{w.Name}}</a></td>
                        <td>{{w.Description}}</td>
                        <td><a :href="w.StartupUrl ? `/#${w.StartupUrl}${w.WorkspaceId}` : `/#/projects/${w.WorkspaceId}`" target="_blank">Open</a></td>
                    </tr>
                </tbody>
            </table>

            <h4 v-else>No workspaces</h4>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, onMounted } from 'vue'
    import { useRoute } from 'vue-router'

    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import { useWorkspacesByOrganizationQueryV1 } from '@Organizations/Workspaces/queries-vue-composables'

    const route = useRoute()
    const tid = computed(() => Number(route.params.tid))

    const {
        runWorkspacesByOrganizationQueryV1,
        modelWorkspacesByOrganizationQueryV1: model
    } = useWorkspacesByOrganizationQueryV1(tid)


    const workspaces = computed(() => model.value?.Workspaces ?? [])

    onMounted(() =>
    {
        document.title = 'Workspaces'
        runWorkspacesByOrganizationQueryV1()
    })
</script>

